import useSWRImmutable from 'swr/immutable'

import { type PremiumContentWithCustomString } from '@/legacy-src/components/premiumContent/hooks/constants'
import { useApis } from '@/legacy-src/contexts/api-context'
import { type ApiEndpoints } from '@/legacy-src/services/api'

const fetchAllowedPremiumContent = async (api: ApiEndpoints) => {
  const res = await api.getAllowedPremiumContent()
  return res.data as PremiumContentWithCustomString[]
}

// this hook fetches the list of premium content that the user can actually open
// this is different from visible premium content which may be shown locked
const useAllowedPremiumContent = () => {
  const { api } = useApis()
  const { data, mutate: refetchAllowedPremiumContent } = useSWRImmutable(['usePremiumContent'], () =>
    fetchAllowedPremiumContent(api),
  )

  // Check if a single premium content item is allowed
  const isPremiumContentAllowed = (item: PremiumContentWithCustomString) => {
    return Array.isArray(data) && data.includes(item)
  }

  // Check if any item from an array of premium content is allowed
  const isAnyPremiumContentAllowed = (items: PremiumContentWithCustomString[]) => {
    return Array.isArray(data) && items.some((item) => data.includes(item))
  }

  return {
    allowedPremiumContent: data,
    refetchAllowedPremiumContent,
    isPremiumContent: Array.isArray(data) && data.length > 0,
    isPremiumContentAllowed,
    isAnyPremiumContentAllowed,
  }
}

export default useAllowedPremiumContent
